import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { take } from 'rxjs';

const apiUrl = environment.apiUrl + 'user/wishlist/product/';

@Injectable({ providedIn: 'root' })
export class WishListService {
  constructor(private http: HttpClient) {}

  // fix in future; post with empty body
  addToWishlist(productSlug: string) {
    return this.http.post(apiUrl + productSlug, '').pipe(take(1));
  }

  removeFromWishlist(productSlug: string) {
    return this.http.delete(apiUrl + productSlug + '/remove').pipe(take(1));
  }

  clearWishlist() {
    return this.http.delete(apiUrl + 'remove_all').pipe(take(1));
  }
}
